module.exports = __webpack_public_path__ + "d05e4aa4efed55c5117f90fa56f9ab68.svg";